import React, { useState } from "react";
import { db } from "../../../firebase";
import { useAuth } from "../../../contexts/AuthContext";
import Modal from "./Modal";
import Alert from "../../Alert";
import { svg } from "../../../resources/Svg";

const DeleteRecord = ({ id, open, setOpen }) => {
  const [isdeleteConfirmed, setIsDeleteConfirmed] = useState(false);
  const { currentUser, userInfo } = useAuth();
  const [errorMsg, setErrorMsg] = useState("");
  const [notificationMsg, setNotificationMsg] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (currentUser != null && isdeleteConfirmed) {
      if (userInfo.isSalary) {
        setNotificationMsg("");
        setErrorMsg("");
        db.salaries
          .doc(id)
          .delete()
          .then(() => {
            setErrorMsg("");
            setNotificationMsg("The Record has been Deleted successfully");
          })
          .catch((error) => {
            setNotificationMsg("");
            setErrorMsg(error.message);
          });
      } else {
        setNotificationMsg("");
        setErrorMsg("");
        db.nonsalaries
          .doc(id)
          .delete()
          .then(() => {
            setErrorMsg("");
            setNotificationMsg("The Record has been Deleted successfully");
          })
          .catch((error) => {
            setNotificationMsg("");
            setErrorMsg(error.message);
          });
      }
    }
  };

  return (
    <>
      <Modal open={open} h="auto" w="auto">
        <div className="flex flex-col space-y-5">
          <div className="flex items-center justify-between">
            <h1 className="text-gray-800 text-xl font-semibold text-center">
              Delete Record
            </h1>
            <button
              className="focus:outline-none"
              onClick={() => {
                setErrorMsg("");
                setNotificationMsg("");
                setOpen(false);
              }}
            >
              <svg
                className="h-6 w-6 text-red-600 "
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div
            style={{ height: "1px" }}
            className="w-full bg-gray-700 bg-opacity-30 rounded-sm"
          ></div>
          <form className=" space-y-6" onSubmit={(e) => handleSubmit(e)}>
            <div className="space-y-6">
              <section className="flex flex-col mb-4">
                <h2 className="py-2 px-3 rounded-md ">
                  Are you sure you want to delete this record? <br />
                  Once you deleted it, you will{" "}
                  <span className="font-bold uppercase text-red-500">
                    never
                  </span>{" "}
                  be able to restore it back.
                </h2>
              </section>
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => setIsDeleteConfirmed(true)}
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Delete Permanently
              </button>
              <button
                onClick={() => setOpen(false)}
                type="submit"
                className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Cancel
              </button>
            </div>
          </form>
          {errorMsg && (
            <Alert
              svg={svg.danger}
              iconFlag={"red-500"}
              textFlag={"red-600"}
              text={errorMsg}
            />
          )}
          {notificationMsg && (
            <Alert
              svg={svg.success}
              bgColor={"green-100"}
              iconFlag={"green-500"}
              textFlag={"green-600"}
              text={notificationMsg}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default DeleteRecord;
